import * as React from "react"
import { Col, Container, Row } from "react-grid-system"
import styled from "styled-components"
import Body from "../atoms/typography/Body"
import H1 from "../atoms/typography/H1"
import H3 from "../atoms/typography/H3"
import { theme } from "../theme"
import { FeatureHighlightModel } from "./models"
import { HorizontalSpacer } from "../atoms/spacers"
import { useContentfulInspectorMode } from "@contentful/live-preview/react"
import { MediaQuery } from "../../utils/design-helpers"

const Section = styled.div`
  background: ${({ theme }) => theme.colors.dark};
  padding: 4rem;

  ${MediaQuery.LG} {
    padding: 2rem;
  }
`

const TabButton = styled(H3)<{ active: boolean }>`
  color: ${({ theme, active }) => (active ? theme.colors.white : theme.colors.greyDark)};
  margin-bottom: 2rem;
  cursor: pointer;

  &::after {
    content: "";
    display: block;
    height: 4px;
    border-radius: 8px;
    background-color: ${({ theme, active }) => (active ? theme.colors.white : theme.colors.greyDark)};
    margin-top: 0.5rem;
  }
`

const FeatureHighlight: React.FC<FeatureHighlightModel> = ({ content = {}, sys, title }) => {
  const [activeTab, setActiveTab] = React.useState<string>(Object.keys(content)[0])
  const inspectorProps = useContentfulInspectorMode({ entryId: sys?.id })

  const names = Object.keys(content)

  const tabs = names.map((name) => (
    <Col key={name} md={12 / names.length} onClick={() => setActiveTab(name)}>
      <Row justify="center">
        <Col xs={8} md={12}>
          <TabButton textAlign="center" active={name === activeTab}>
            {name}
          </TabButton>
        </Col>
      </Row>
    </Col>
  ))

  const description = content[activeTab]

  return (
    <Section {...inspectorProps({ fieldId: "title" })}>
      <Container>
        <Row justify="center">
          <Col style={{ maxWidth: "800px" }}>
            <Row justify="center">
              <H1 textAlign="center" color={theme.colors.white}>
                {title}
              </H1>
            </Row>
            <HorizontalSpacer spacing={2} />
            <Row justify="center" align="end">
              {tabs}
            </Row>
            <Body color={theme.colors.white}>{description}</Body>
          </Col>
        </Row>
      </Container>
    </Section>
  )
}

export default FeatureHighlight
